import { injectable, inject } from 'inversify';
import { QuestionCommand, questionStateReducer } from './question-state-reducer';
import { SuspendDataStore, SuspendDataStateStore, SuspendDataStoreSymbol } from '@/app/tracking/common';
import { QuestionState, defaultQuestionState } from './question-state'

interface QuestionsSuspendData {
  questions: QuestionState[];
}

@injectable()
export class QuestionSuspendDataStore {

  private store: SuspendDataStateStore<QuestionState, unknown, QuestionCommand>;

  constructor(
    @inject(SuspendDataStoreSymbol)
    suspendDataStore: SuspendDataStore<QuestionsSuspendData>) {

    this.store = new SuspendDataStateStore(
      () => suspendDataStore.get2('questions'),
      (data: QuestionState[]) => suspendDataStore.update2('questions', data),
      (id) => defaultQuestionState(id),
      questionStateReducer);
  }

  public async query(ids: string[] | 'all') {
    return this.store.query(ids);
  }

  public async execute(command: QuestionCommand) {
    await this.store.execute(command);
  }
}
